import api from 'api/api'
import { toast } from "react-toastify"

import { API_URL } from 'constants/index'

export const GET_OPENINGS = "[MANAGE CASH] GET OPENINGS"

export const CRUD_OPENING = "[MANAGE CASH] CRUD OPENING"

export const GET_OPENING_INCOMES_AND_EXPENSES = "[MANAGE CASH] GET OPENING INCOMES AND EXPENSES"

export const GET_CREDIT_NOTES_BY_CASH_REGISTER = "[MANAGE CASH] GET CREDIT NOTES BY CASH REGISTER"

export function getOpenings({ page = 1, pageSize = 10, startDate = '', endDate = '', status = '', search = '', }) {
  const request = api.get(`/caja/registros`, {
    params: {
      page,
      por_pagina: pageSize,
      fecha_inicio: startDate,
      fecha_fin: endDate,
      estado: status,
      busqueda: search
    }
  })
  return (dispatch) => {
    dispatch({ type: GET_OPENINGS, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_OPENINGS, payload: { loading: false, ...response.data } })
    }).catch((error) => {
      dispatch({ type: GET_OPENINGS, payload: { loading: false } })
      console.log(error);
    })
  }
}

export function saveOpening(from) {
  const request = api.post(`/caja/abrir-caja`, from)
  return (dispatch) => {
    dispatch({ type: CRUD_OPENING, payload: { loading: true, crud: false } })
    request.then((response) => {

      if (parseInt(response.data.status) !== 200) {
        dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
      toast.error("Error inesperado, no se pudo realizar la apertura de caja.")
      console.log(CRUD_OPENING, error)
    })
  }
}

export function getOpeningIncomesAndExpenses(openingId) {
  const request = api.get(`/caja/ingresos-egresos/${openingId}`)
  return (dispatch) => {
    dispatch({ type: GET_OPENING_INCOMES_AND_EXPENSES, payload: { loading: true, data: null } })
    request.then((response) => {

      dispatch({ type: GET_OPENING_INCOMES_AND_EXPENSES, payload: { loading: false, data: response.data.data } })
    }).catch((error) => {
      console.log(GET_OPENING_INCOMES_AND_EXPENSES, error)
      dispatch({ type: GET_OPENING_INCOMES_AND_EXPENSES, payload: { loading: false, data: null } })
    })
  }
}

export function getCreditNotesByCashRegisterId(cashRegisterId) {
  const request = api.get(`/caja/notas-credito/${cashRegisterId}`)
  return (dispatch) => {
    dispatch({ type: GET_CREDIT_NOTES_BY_CASH_REGISTER, payload: { loading: true, data: null } })
    request.then((response) => {

      dispatch({ type: GET_CREDIT_NOTES_BY_CASH_REGISTER, payload: { loading: false, ...response.data } })
    }).catch((error) => {
      console.log(GET_CREDIT_NOTES_BY_CASH_REGISTER, error)

      dispatch({ type: GET_CREDIT_NOTES_BY_CASH_REGISTER, payload: { loading: false, data: null } })
    })
  }
}

export function closeOpening(from) {
  const request = api.post(`/caja/cerrar-caja`, from)
  return (dispatch) => {
    dispatch({ type: CRUD_OPENING, payload: { loading: true, crud: false } })
    request.then((response) => {

      if (parseInt(response.data.status) !== 200) {
        dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
      toast.error("Error inesperado, no se pudo cerrar la caja.")
      console.log(CRUD_OPENING, error)
    })
  }
}

export function revertOpeningClosed(openingId) {
  const request = api.post(`/caja/revertir-cierre-caja/${openingId}`)
  return (dispatch) => {
    dispatch({ type: CRUD_OPENING, payload: { loading: true, crud: false } })
    request.then((response) => {

      if (parseInt(response.data.status) !== 200) {
        dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
      toast.error("Error inesperado, no se pudo revertir el cierre de caja.")
      console.log(CRUD_OPENING, error)
    })
  }
}

export const GET_CASH_MOVEMENTS = "[MANAGE CASH] GET CASH MOVEMENTS"

export function searchCashMovements({ page = 1, pageSize = 50, startDate = '', endDate = '', cashierId = '', movementType = '', search = '' }) {
  const request = api.get(`/caja/movimientos/search`, {
    params: {
      page,
      por_pagina: pageSize,
      fecha_inicio: startDate,
      fecha_fin: endDate,
      cajero_id: cashierId,
      tipo_movimiento: movementType,
      busqueda: search,
    }
  })
  return (dispatch) => {
    dispatch({ type: GET_CASH_MOVEMENTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_CASH_MOVEMENTS, payload: { loading: false, ...response.data } })
    }).catch((error) => {
      console.log(GET_CASH_MOVEMENTS, error)
      dispatch({ type: GET_CASH_MOVEMENTS, payload: { loading: false } })
    })
  }
}

export function deleteOpening(openingId) {
  const request = api.post(`/caja/anular-caja/${openingId}`)
  return (dispatch) => {
    dispatch({ type: CRUD_OPENING, payload: { loading: true, crud: false } })
    request.then((response) => {

      if (parseInt(response.data.status) !== 200) {
        dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
        toast.error(response.data.message)
        return
      }
      dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: true } })
      toast.success(response.data.message)
      setTimeout(() => {
        dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_OPENING, payload: { loading: false, crud: false } })
      toast.error("Error inesperado, no se pudo anular la caja.")
      console.log(CRUD_OPENING, error)
    })
  }
}